import { Card, CardHeader, CardContent } from "@material-ui/core";

import AddTwilioWrapper from "./AddTwilioWrapper";
import { TwilioSubaccountSelectForTenant } from "./TwilioSelect";

export default function Settings(): JSX.Element {
  return (
    <Card>
      <CardHeader title="Twilio Configuration" />
      <CardContent>
        <div>
          <TwilioSubaccountSelectForTenant />
          <hr />
          <AddTwilioWrapper />
        </div>
      </CardContent>
    </Card>
  );
}
